export const getSafeRedirectPath = (rawPath: string | null | undefined) => {
  if (!rawPath) {
    return null
  }

  if (!rawPath.startsWith('/') || rawPath.startsWith('//')) {
    return null
  }

  return rawPath
}
